<app-d-form-group *ngIf="formLoaded" (control)="courseFormControl = $event" (submit)="onSubmit($event)"
  [defaultValues]="defaultValues" (cancel)="onCancel($event)" [formArray]="courseForm">
</app-d-form-group>
<div style="display:none">
  <img #thumbnailLogoChild [src]="uploadedThumbnailLogo">
</div>